<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>

  <mat-card appearance="outlined">
    <div *ngIf="screen && screen.uuid">Screen UUID: {{screen.uuid}}</div>
    <div *ngIf="organisationCustomer">Customer: {{organisationCustomer}}</div>
    <div class="form-container">
      <ng-template formHost></ng-template>
    </div>
    <div class="button-right-container">
      <button (click)="onSave()" class="ibexfusion-raised-button" mat-button>Save</button>
    </div>
  </mat-card>

</page-content>
